export const DEFAULT_NOTIFICATIONS_CFG = {
  n1: { enabled: true },
  n3: { enabled: true, weekPeriodicity: 2 },
  n4: { enabled: true },
  n6: { enabled: true, includeSurvey: true },
  n8: { enabled: true },
  push: { enabled: true }
};

export const DEFAULT_PRODUCTIVITY_CFG = { kepler: { enabled: false } };

export const NO_EDITOR_PLAN: string = 'no-editor';

export const NO_EDITOR_PLAN_BASE: any = {
  editorAccess: false,
  reportsType: 'basic',
  apiAccess: 'false',
  configurable: 'false'
};

export const TERMS_URL_LANGS: any = ['en', 'es', 'fr', 'de', 'pt', 'nl'];

export const CLIENT_DETAIL_BUTTON_ACTIONS = {
  showList: true,
  options: [
    { key: 'stripe', value: 'actions.linkStripe', profile: 'clients.stripe' },
    { key: 'deleteInfo', value: 'actions.deleteClientData', profile: 'clients.deleteInfo' },
    { key: 'delete', value: 'actions.deleteClient', profile: 'clients.delete' }
  ]
};
